'use strict';

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

require('normalize.css');

require('font-awesome/css/font-awesome.min.css');

require('leaflet/dist/leaflet.css');

require('leaflet/dist/leaflet.js');

require('angular-loading-bar/build/loading-bar.min.css');

require('angular-growl-v2/build/angular-growl.min.css');

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _angularLoadingBar = require('angular-loading-bar');

var _angularLoadingBar2 = _interopRequireDefault(_angularLoadingBar);

var _dropdown = require('angular-ui-bootstrap/src/dropdown');

var _dropdown2 = _interopRequireDefault(_dropdown);

var _carousel = require('angular-ui-bootstrap/src/carousel');

var _carousel2 = _interopRequireDefault(_carousel);

var _modal = require('angular-ui-bootstrap/src/modal');

var _modal2 = _interopRequireDefault(_modal);

var _angularTranslate = require('angular-translate');

var _angularTranslate2 = _interopRequireDefault(_angularTranslate);

var _angularAnimate = require('angular-animate');

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _angularStorage = require('angular-storage');

var _angularStorage2 = _interopRequireDefault(_angularStorage);

var _ngFileUpload = require('ng-file-upload');

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

require('angular-growl-v2/build/angular-growl.min');

require('angular-summernote/dist/angular-summernote.min');

var _app = require('./app.component');

var _app2 = _interopRequireDefault(_app);

var _common = require('./common/common');

var _common2 = _interopRequireDefault(_common);

var _components = require('./components/components');

var _components2 = _interopRequireDefault(_components);

var _image = require('./services/imageService/image');

var _image2 = _interopRequireDefault(_image);

var _account = require('./services/accountService/account');

var _account2 = _interopRequireDefault(_account);

var _report = require('./services/reportService/report');

var _report2 = _interopRequireDefault(_report);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_angular2.default.module('app', [_angularUiRouter2.default, _angularLoadingBar2.default, _dropdown2.default, _angularTranslate2.default, _angularStorage2.default, _angularAnimate2.default, _carousel2.default, _modal2.default, _ngFileUpload2.default, 'angular-growl', 'summernote', // vedi index.html per le dipendenze di summernote.js
_common2.default, _components2.default, _image2.default, _account2.default, _report2.default]).config(function ($locationProvider, $urlRouterProvider) {
  'ngInject';
  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
  // #how-to-configure-your-server-to-work-with-html5mode
  // $locationProvider.html5Mode(true).hashPrefix('!');

  $urlRouterProvider.otherwise('/');
}).config(function ($translateProvider) {
  'ngInject';

  $translateProvider.translations('it', (0, _defineProperty3.default)({
    'CULTURE': "Cultura",
    'INFORMATION': "Informazioni",
    'ITINERARY': "Itinerari",
    'NATURE': 'Natura',
    'TYPICALPRODUCT': 'Prodotti tipici',
    'SERVICE': 'Servizi e ricettività',
    'OUTDOOR': 'Outdoor'
  }, 'ITINERARY', 'Itinerari'));

  $translateProvider.preferredLanguage('it');
}).config(function (growlProvider) {
  'ngInject';

  growlProvider.globalTimeToLive(5000);
  growlProvider.globalDisableCountDown(true);
  growlProvider.globalPosition('top-center');
}).config(function (cfpLoadingBarProvider) {
  'ngInject';

  cfpLoadingBarProvider.spinnerTemplate = '<div class="sk-cube-grid">' + '  <div class="sk-cube sk-cube1"></div>' + '  <div class="sk-cube sk-cube2"></div>' + '  <div class="sk-cube sk-cube3"></div>' + '  <div class="sk-cube sk-cube4"></div>' + '  <div class="sk-cube sk-cube5"></div>' + '  <div class="sk-cube sk-cube6"></div>' + '  <div class="sk-cube sk-cube7"></div>' + '  <div class="sk-cube sk-cube8"></div>' + '  <div class="sk-cube sk-cube9"></div>' + '</div>';

  // '<div class="loading">' +
  // '  <span>Caricamento...</span>' +
  // '</div>'
}).config(function ($qProvider) {
  'ngInject';

  $qProvider.errorOnUnhandledRejections(false);
}).config(function ($httpProvider) {
  'ngInject';

  $httpProvider.interceptors.push('Auth');
})
/* .constant('SERVER_URL', 'http://localhost:8080/api') */
.constant('SERVER_URL', 'https://www.api.parco.nino.cloud/api').run(function ($http, store, $state, $location) {
  'ngInject';

  if (store.get("token") && $location.path().indexOf("confirmRegistration") == -1) {
    $http.defaults.headers.common.Authorization = store.get("token");

    // Reindirizza alla dashboard solo se c'è un token valido
    // e l'utente è sulla pagina di login.
    if ($location.path() === '' || $location.path() === '/' || $location.path().indexOf("login") > -1) {
      $state.go("dashboard.list", { modelEnum: 'CULTURE' });
    }
  }
}).component('app', _app2.default);
// import 'bootstrap-css-only/css/bootstrap.css'; //bootstrap 4 va in conflitto con now ui kit


// WEBPACK FOOTER //
// ./client/app/app.js